import { store } from './store';
import Vue from 'vue'
import { EquatorialCoord } from '@hscmap/angle';

export function develSetup($root: Vue) {
  // @ts-ignore
  window.hscmap = {
    goto(input: string, fovy?: number) {
      const vf = store.currentGlobe().viewFactory
      fovy = fovy || vf.fovy
      input = input.trim()
      try {
        const coord = EquatorialCoord.parse(input!)
        vf.jumpTo({ fovy }, { coord })
      } catch (e) {
        alert(`Parse Error: ${e}`)
      }
    },
    get store() {
      return store
    },
    get $root() {
      return $root
    },
  }
}
